/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1UserRoleString } from '../../entities/v1/UserRoleString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1UserRoleStringSchema = z.enum(['api_integrator', 'recruiter']) as unknown as ToZod<V1UserRoleString>